import Markdown from 'markdown-to-jsx'
import styles from './whatIs.module.css'


export default function WhatIs({ data }) {
  return (
    <>
      <section className={`container-full ${styles.container}`}>
        <div className={`flex-row ${styles.content}`}>
          <img src={data.imagem.url} />
          <div className={styles.contentText}>
            <div className={styles.title}>
              <div className={styles.parallelogramDetail} />
              <h1>{data.titulo}</h1>
            </div>
            <Markdown>{data.texto}</Markdown>
          </div>
        </div>
      </section>
    </>
  )
}
